module.exports = __webpack_public_path__ + "img/KinokoTable58.73bfbe13.jpg";